import { getSocietyTotalShares } from 'modules/society/utils/getSocietyTotalShares';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

type UseGetUnitsPriceProps = {
  simulatedSocietyValue: number;
  includeAllUnits: boolean;
};

const getFutureShares = (plans: any[]) => {
  if (!plans) {
    return 0;
  }

  return plans.reduce((totalShares, plan) => {
    if (plan?.isDraft) {
      return totalShares;
    }
    return totalShares + (plan?.sharesTotal || 0);
  }, 0);
};

export const useGetUnitsPrice = ({
  includeAllUnits,
  simulatedSocietyValue,
}: UseGetUnitsPriceProps) => {
  const society = useSelector((state: State) => state.society?.actualSociety);
  const plans = useSelector((state: State) => state.plans);

  const [unitsPrice, setUnitsPrice] = useState<number>(0);

  useEffect(() => {
    let societyShares = getSocietyTotalShares(society);

    if (includeAllUnits) {
      const futureShares = getFutureShares(plans);
      societyShares += futureShares - society.sharesCount?.future;
    }

    const unitsPrice = simulatedSocietyValue / societyShares;
    setUnitsPrice(unitsPrice);
  }, [includeAllUnits, plans, simulatedSocietyValue, society]);

  return {
    data: { unitsPrice },
    isLoading: false,
    isError: false,
    actions: {},
  };
};
